import React from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { FaBars } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useGlobalContext } from "../context";

const Header = () => {
  const { openSidebar } = useGlobalContext();

  return (
    <section className="header">
      <div className="header-container">
        <NavLink to="/">
          <img
            src="/images/affordable-logo.jpg"
            alt="Company Logo"
            className="header-logo"
          />
        </NavLink>
        <Navbar />
        <Sidebar />
        <FaBars onClick={openSidebar} className="header-bars" />
      </div>
    </section>
  );
};

export default Header;
